export const MGM_CTA_EXPERIMENT_ID = '351933';
export const MGM_CTA_EXPERIMENT_VARIANT = '53532';
export const MGM_CTA_PURPLE_EXPERIMENT_VARIANT = '53533';

export const CHANGES_PREVIEW_XP_ID = '351021';
export const CHANGES_PREVIEW_XP_VARIANT_ID = '52108';

export const MAGIC_LINK_FIX_EXPERIMENT_ID = '352203';
export const MAGIC_LINK_FIX_EXPERIMENT_ORIGINAL = '53902';
export const MAGIC_LINK_FIX_EXPERIMENT_VARIANT = '53903';
